<template>
<v-container>

  <!-- <object data="https://wuerfeldev.de" style="position:absolute;width:100%;height:100%;" type="text/html">
      <iframe src="https://wuerfeldev.de" style="position:absolute;width:100%;height:100%;"></iframe>
  </object> -->

  <!-- <embed src="https://wuerfeldev.de" style="position:absolute;width:100%;height:100%;" /> -->




  <!--
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex xs12 sm5 class="text-xs-center text-md-right">

      </v-flex>
      <v-flex xs12 sm7 class="vcenter">



      </v-flex>
    </v-layout>
  </v-container>


  <br v-for="n in 100">
  -->

  <IconTable v-bind:bct="false">
    <svg slot="ico">
      <text x="0" y="200" fill="none" stroke="#757575" stroke-width="4" class="material-icons anim_cont" style="font-size:200px;">&#xE7FD;</text>
      <text x="65" y="102" fill="white" stroke-width="0" class="material-icons" style="font-size:70px;">face</text>
    </svg>

    <div class="display-1">Contact me</div><br> E-Mail:
    <br>
    <span class="myemail">&#64;</span>
  </IconTable>

  <div class="hidden-sm-and-up"><br><br><br></div>

  <IconTable v-bind:bct="false" v-bind:fsize="150">
    <svg slot="ico">
      <text x="0" y="150" fill="none" stroke="#757575" stroke-width="3" class="material-icons anim_cont_nofill" style="font-size:150px;">local_pizza</text>
    </svg>

    <div class="headline">Buy me a pizza</div> I really appreciate your donation. Even if it's just a layer cheese.<br>Get in contact
  </IconTable>


</v-container>
</template>

<script>
import IconTable from '../components/IconTable.vue'

export default {
  name: "contact-page",
  components: {
    IconTable
  }
}
</script>
<style>
.anim_cont {
  /* chrome bug https://stackoverflow.com/a/26778831/4346956 hover doesnt work*/
  /*animation: stroke_nofill_cont 2.5s linear 0.2s forwards, pulsing_cont 20s ease -7s infinite alternate*/
  ;
  animation: stroke_fill_cont 2.5s linear 0.1s forwards;
  stroke-dasharray: 350;
  stroke-dashoffset: 350;
  opacity: 0;
}

.anim_cont_nofill {
  animation: stroke_nofill_cont 4s linear .6s forwards/*, pulsing_cont_nofill 20s ease -7s infinite alternate*/
  ;
  stroke-dasharray: 500;
  stroke-dashoffset: 500;
  opacity: 0;
}

@keyframes stroke_fill_cont {
  0% {
    fill: white;
    opacity: 0;
  }
  80% {
    fill: white;
    stroke-dashoffset: 0;
  }
  100% {
    fill: #757575;
    stroke-dashoffset: 0;
    opacity: 1;

  }
}


@keyframes pulsing_cont {
  0% {
    fill: white;
    stroke: black;
  }
  40% {
    stroke: black;
  }
  45% {
    fill: white;

  }
  55% {
    fill: #757575;
    stroke: #757575;
  }
  100% {
    stroke: #757575;
    fill: #757575;
  }
}




@keyframes stroke_nofill_cont {
  0% {
    opacity: 0;
  }
  80% {
    stroke-dashoffset: 0;
  }
  100% {
    stroke-dashoffset: 0;
    opacity: 1;

  }
}

@keyframes pulsing_cont_nofill {
  0% {
    stroke: black;
  }
  40% {
    stroke: black;
  }
  55% {
    stroke: #757575;
  }
  100% {
    stroke: #757575;
  }
}
</style>



// WEBPACK FOOTER //
// src/content/contact-page.vue